// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 104px;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.0588235294);
  padding: 16px;
}

.step-label {
  display: flex;
  text-align: center;
  z-index: 1;
  min-width: 100px;
  gap: 0.5rem;
}

.step-number {
  width: 24px;
  height: 24px;
  background-color: #e9ecef;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-weight: bold;
  color: #6c757d;
}

.step-title {
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 0.25rem;
}

.step-label.active .step-number {
  background-color: #007bff;
  color: white;
}

.step-label.active .step-title {
  color: #007bff;
  font-weight: bold;
}

.step-label.completed .step-number {
  background-color: #007bff;
  color: white;
}

.step-label.completed .step-title {
  color: #007bff;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/components/src/lib/components/SchemaFormStepPage/SchemaFormStep.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,uDAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
